import { render } from "./OperationLogs.vue?vue&type=template&id=34c77f98&scoped=true"
import script from "./OperationLogs.vue?vue&type=script&lang=js"
export * from "./OperationLogs.vue?vue&type=script&lang=js"

import "./OperationLogs.vue?vue&type=style&index=0&id=34c77f98&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c77f98"]])

export default __exports__